export const additional = {
  brightYellow: '#FFE033',
  radiantGold: '#AC8100',
  hotPink: '#ED4C82',
  dangerRed: '#FF333D',
  turquoise: '#00E5DA',
  limeGreen: '#C2FF1A',
  vibrandBlue: '#0073EE',
  mysteriousPurple: '#8711DC',
  warmGreen: '#C4D19A',
  coolGreen: '#A3D0B8',
  lightBlue: '#B2DEF3',
  lightViolet: '#B2DEF3',
  darkViolet: '#B7BBCE',
} satisfies Record<string, string>
